//Проверка на версию разработки перенесена в Observer.js
function timeoutDelay() {
  return process.env.NODE_ENV !== 'production' ? 2000 : 0;
}

export default timeoutDelay;